import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { DataCodeEnum } from "../../../constants/enum";
import { useState } from "react";
import PageContentEditor from "../../../components/PageContentEditor";

const dataContentOptions = [
  {
    code: DataCodeEnum.WHAT_IS_NUMEROLOGY,
    name: "What is numerology?",
  },
  {
    code: DataCodeEnum.THE_MEANING_OF_LIFE_PATH_NUMBER_AND_DESTINY_NUMBER,
    name: "The meaning of Life Path Number and Destiny Number",
  },
  {
    code: DataCodeEnum.MEANING_OF_NUMBERS_INTRODUCTION,
    name: "Meaning of Number - Introduction",
  },
  {
    code: DataCodeEnum.MEANING_OF_NUMBERS_1,
    name: "Meaning of Number - 1",
  },
  {
    code: DataCodeEnum.MEANING_OF_NUMBERS_2,
    name: "Meaning of Number - 2",
  },
  {
    code: DataCodeEnum.MEANING_OF_NUMBERS_3,
    name: "Meaning of Number - 3",
  },
  {
    code: DataCodeEnum.MEANING_OF_NUMBERS_4,
    name: "Meaning of Number - 4",
  },
  {
    code: DataCodeEnum.MEANING_OF_NUMBERS_5,
    name: "Meaning of Number - 5",
  },
  {
    code: DataCodeEnum.MEANING_OF_NUMBERS_6,
    name: "Meaning of Number - 6",
  },
  {
    code: DataCodeEnum.MEANING_OF_NUMBERS_7,
    name: "Meaning of Number - 7",
  },
  {
    code: DataCodeEnum.MEANING_OF_NUMBERS_8,
    name: "Meaning of Number - 8",
  },
  {
    code: DataCodeEnum.MEANING_OF_NUMBERS_9,
    name: "Meaning of Number - 9",
  },
  {
    code: DataCodeEnum.WHAT_ARE_ANGEL_NUMBERS,
    name: "What are angel numbers?",
  },
  {
    code: DataCodeEnum.MASTER_NUMBERS,
    name: "Master Numbers",
  },
  {
    code: DataCodeEnum.NUMEROLOGY_INDICATORS_LIFE_PATH_HOW_TO_CALCULATE,
    name: "How to calculate Life Path number",
  },
  {
    code: DataCodeEnum.NUMEROLOGY_INDICATORS_LIFE_PATH,
    name: "Life Path",
  },
  {
    code: DataCodeEnum.NUMEROLOGY_INDICATORS_EXPRESSION_HOW_TO_CALCULATE,
    name: "How to calculate Expression number",
  },
  {
    code: DataCodeEnum.NUMEROLOGY_INDICATORS_EXPRESSION,
    name: "Expression number",
  },
  {
    code: DataCodeEnum.NUMEROLOGY_INDICATORS_BIRTHDAY,
    name: "Birthday number",
  },
  {
    code: DataCodeEnum.NUMEROLOGY_INDICATORS_NAME,
    name: "Name number",
  },
];
const ListNumbers = () => {
  const [codeSelected, setCodeSelected] = useState<string | null>(null);
  const dataContent = dataContentOptions.find(
    (option) => option.code === codeSelected
  );
  return (
    <Box sx={{}}>
      <Box
        sx={{
          padding: "10px",
        }}
      >
        <Typography
          color="primary"
          sx={{
            fontWeight: "bold",
            fontSize: "24px",
            marginBottom: "10px",
          }}
        >
          Numerology
        </Typography>
        <TextField
          select
          name="code"
          label="Data content"
          fullWidth
          value={codeSelected}
          onChange={(event) => {
            setCodeSelected(event.target?.value);
          }}
          required
          sx={{
            backgroundColor: "#F7FAFC",
          }}
        >
          {dataContentOptions.map((option) => (
            <MenuItem key={option.code} value={option.code}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Box
        sx={{
          height: "calc(100vh - 120px)",
        }}
      >
        {!!dataContent && (
          <PageContentEditor
            dataCode={dataContent.code}
            dataName={dataContent.name}
          />
        )}
      </Box>
    </Box>
  );
};
export default ListNumbers;
